import { Injectable } from '@angular/core';
import { GlobalMessageActions, GlobalMessageService, GlobalMessageType, Translatable } from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class CustomGlobalMessageService extends GlobalMessageService{
  override add(
    text: string | Translatable,
    type: GlobalMessageType,
    timeout?: number
  ): void {
    if (typeof text === 'string' && text?.toUpperCase().includes('PRODUCT WITH CODE')) {
      console.error('PRODUCT NOT FOUND!');
      return;
    }

    if (
      typeof text === 'string' &&
      (text.includes('Exception while calling Product Reference Api') ||
        text.includes('IllegalArgumentError'))
    ) {
      console.warn('PRODUCT REFERENCE ERROR SUPPRESSED.');
      return;
    }

    this.store.dispatch(
      new GlobalMessageActions.AddMessage({
        text: typeof text === 'string' ? { raw: text } : text,
        type,
        timeout,
      })
    );
  }
}
